import React, { Component } from "react";
import LoanGroupContainerV2 from "./LoanGroupContainerV2";
import LenderResultRowV2 from "./LenderResultRowV2";
import LenderResultRowV2Mobile from "./LenderResultRowV2Mobile";
import { defaultVaules, creditScoreList, loanPurposeList,AcornExcludestateList } from "./AppData";
import { redirectUrl, trackGoalId } from "./LoanOfferListV2";
import HeaderIntroduction from "./HeaderIntroduction";


class MainPanelContainerV2 extends Component {
    constructor(props) {
        super(props);
        this.zeroResultDueToLicense = false;
        this.state = { 
            sortBy: defaultVaules.sortBy,
            offsetWidth : 0,
            displayFiler: false
         }; // monthly_payment        
        this.handleSortByChange = this.handleSortByChange.bind(this);
        // this.closeFilters = this.closeFilters.bind(this); 
        
        const AcornExcludestateListArray=[]; //Exclude Acorn not available state
        AcornExcludestateList.map((val,key)=>{
            AcornExcludestateListArray.push(val['key']);
        });
        this.state.AcornExcludestateListArray=AcornExcludestateListArray;
    }
   
    // updateDimensions = () => {
    //     var width = document.getElementById('acorn-body');
    //     this.setState({ deviceWidth: width.offsetWidth });   
    // };
    // componentDidMount() {
    //     var that = this;
    //     window.addEventListener("resize", (ev) => {
    //         var width = document.getElementById('acorn-body');
    //         that.setState({ deviceWidth : width.offsetWidth});
    //     });
    //     // var width = document.getElementById('acorn-body') !== null && document.getElementById('acorn-body') ? document.getElementById('acorn-body').offsetWidth : 0;
    //     // this.setState({ deviceWidth: width });
    //     // window.addEventListener('resize', this.updateDimensions);
    // }
    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.updateDimensions);
    // }
    handleSortByChange(sortBy) {
        this.setState({ sortBy: sortBy });
    }
    unFormatAmount(formattedValue) {
        if(formattedValue){
            return formattedValue.toString().replace(this.currencySymbol, '').replace(/,/g, '');
        } else {
            return formattedValue;
        }
    }
    GetLoanPurposeIndex(selectedLoanPupose, index){
        const filteredLoanPupose = loanPurposeList.filter(lp => {
            if(selectedLoanPupose) {
                return (lp.index.toLowerCase() === selectedLoanPupose.toLowerCase() || lp.key.toLowerCase() === selectedLoanPupose.toLowerCase() || lp.text.toLowerCase() === selectedLoanPupose.toLowerCase());
            }
            return filteredLoanPupose;
        });
        if(filteredLoanPupose.length > 0) {
            if(index === 0) {
                return filteredLoanPupose[0].key.toLowerCase();
            } else if (index === 1) {
                return filteredLoanPupose[0].text.toLowerCase();
            } else if (index === 2)  {
                return filteredLoanPupose[0].label.toLowerCase();
             }  else if (index === 3) {
                return filteredLoanPupose[0].index;
             }
           
        } else {
            return '';
        }
    }
    filterRecords() {
        const rows = [];
        const filtteredrows = [];
        const creditScores = this.props.creditScore.split("-");
        const loanAmount = this.unFormatAmount(this.props.loanAmount);
        const annualIncome = this.props.annualIncome;
        const minCreditScore = creditScores[0];
        const maxCreditScore = creditScores[1];
        const loanPurpose = this.props.loanPurpose;
        const lenderState = this.props.lenderState;
        
        this.zeroResultDueToLicense = false;
        var count = 0;
        if(this.props.lenders) {
            this.props.lenders.forEach((lenderDetail) => {
                if(lenderDetail && lenderDetail.lenderId !== 'primerates') { //  primerates error fix
                    const selectedCreditScore = this.getCreditScoreLabel();
                    if(Array.isArray(lenderDetail.min_fico_score_text) === false|| lenderDetail.min_fico_score_text.indexOf(selectedCreditScore) === -1){
                        return;
                    }
                  
                    // Filter by loan amount
                    if (loanAmount < lenderDetail.min_loan_amount || loanAmount > lenderDetail.max_loan_amount) {
                        return;
                    }
                   
                    // Filter by annual income
                    if (annualIncome < lenderDetail.min_income) {
                        // console.log("minimum income")
                        return;
                    } 
                  
                   
                    // Filter by Loan Purpose
                    if (lenderDetail.loanPurposeExclusions !== undefined && lenderDetail.loanPurposeExclusions.length > 0) {
                        let exclude = lenderDetail.loanPurposeExclusions.filter((element) => {
                            if(element !== undefined) {
                            return (this.GetLoanPurposeIndex(loanPurpose,2) === this.GetLoanPurposeIndex(element,2) ); } else {return null; }
                        });
                        if(exclude.length > 0) return;
                    }  
                    // Filter by lender//
                    if(this.props.lenderParams){
                        const acceptLender = this.props.lenderParams.split(',');                        
                        const LenderID=(lenderDetail.lender)
                        const newAcceptLender = acceptLender.find(element => {
                            return element.toLowerCase() === LenderID.toLowerCase();
                        }); 
                        if(!newAcceptLender){
                          return;
                        }
                    }else if(window[this.props.rootId].lender){
                        const acceptLender = window[this.props.rootId].lender.split(',');
                        const LenderID=(lenderDetail.lender).toLowerCase();
                        const newAcceptLender = acceptLender.find(element => {
                            return element.toLowerCase() === LenderID.toLowerCase();
                        }); 
                        if(!newAcceptLender){
                          return;
                        }
                    }else{

                    }
                    // Filter by lender State//
                 
                    if(lenderState!=='' && lenderState!=='Select' && lenderState!=='SELECT'){
                        if(lenderDetail.state  && lenderDetail.state.key && lenderDetail.state.key.includes(lenderState)===false){
                            return
                        }else if(this.state.AcornExcludestateListArray.includes(lenderState)){
                            return null;
                        }
                    }
                

                }            
                if( lenderDetail &&  lenderDetail.lenderId !== 'primerates') { //  primerates error fix
                    filtteredrows.push(lenderDetail);
                }
            });
        
        var primeratesDetail = this.props.lenders ? this.props.lenders.filter(element => {
            return element && element.lenderId === 'primerates'; //  primerates error fix
        }) : [] ;

        if(primeratesDetail.length > 0 && this.props.listInjection && this.props.listInjection.listIndex) {
            if(filtteredrows.length > this.props.listInjection.listIndex) {                
                primeratesDetail[0].sortIndex = this.props.listInjection.listIndex - 2;
            } else {
                primeratesDetail[0].sortIndex = this.props.listInjection.partnerID;
            }
            filtteredrows.splice(primeratesDetail[0].sortIndex, 0,primeratesDetail[0]);
        }
        var sortedLenders = filtteredrows;;  
        if(sortedLenders.length > 1 && this.props.sortByValue !== "select"){
            if(this.props.sortByValue == "apr_l_h"){
                sortedLenders.sort((a, b) => {
                    let mpA = a.aprmin;
                    let mpB = b.aprmin;
                    return mpA - mpB; 
                });
            } else if(this.props.sortByValue == "term_l_h"){
                sortedLenders.sort((a, b) => {
                    let mpA = Number( a.min_term );
                    let mpB = Number( b.min_term );
                    let mpC = Number( a.max_term );
                    let mpD = Number( b.max_term );
                    return mpA - mpB || mpC - mpD; 
                });
            } else if(this.props.sortByValue == "term_h_l"){
                sortedLenders.sort((a, b) => {
                    let mpA = Number( a.max_term);
                    let mpB = Number( b.max_term );
                    let mpC = Number( a.min_term );
                    let mpD = Number( b.min_term );
                    return mpB - mpA || mpD - mpC; 
                });
            } else if(this.props.sortByValue == "loanamount_l_h"){
                sortedLenders.sort((a, b) => {
                    let mpA = a.max_loan_amount;
                    let mpB = b.max_loan_amount;
                    return mpA - mpB; 
                });
            } else if(this.props.sortByValue == "loanamount_h_l"){
                sortedLenders.sort((a, b) => {
                    let mpA = a.max_loan_amount;
                    let mpB = b.max_loan_amount;
                    return mpB - mpA; 
                });
            }
        }
        sortedLenders.forEach((lenderDetail) => {
            count++;
            if(lenderDetail.lenderId !== 'primerates') {

             rows.push(
            
             <LenderResultRowV2 lender={lenderDetail}
                    loanAmount={loanAmount}                    
                    loanPurpose={this.GetLoanPurposeIndex(this.props.loanPurpose,3)}
                    key={lenderDetail.lenderId}
                    applyLink={lenderDetail.apply.link}
                    ctaBtnLink={this.GenerateApplyLink()}
                    redirectUrl={redirectUrl} 
                    indexCount={count}
                    currentDevice={this.props.currentDevice}
                    IsPRLender={false}
                    showSingleLender={this.props.showSingleLender}
                    currentBrowser={this.props.currentBrowser}
                    SID7={this.props.SID7}
                    SID8={this.props.SID8}
                    SID9={this.props.SID9}
                    SID10={this.props.SID10}
                    SortVersion={this.props.SortVersion}
                    creditScore={this.props.creditScore}
                    annualIncome={this.props.annualIncome}
                    versionLP={this.props.versionLP}
                    trackGoalId={trackGoalId}
                    readOnly={this.props.readOnly}
                    loanAmountBC={this.props.loanAmountBC} loanPurposeBC={this.props.loanPurposeBC}
                    partnerid={this.props.partnerid} gclid={this.props.gclid} featured={this.props.featured}
                    programid={this.props.programid} campaignid={this.props.campaignid} utmSource={this.props.utmSource}
                    utmMedium={this.props.utmMedium} utmTerm={this.props.utmTerm} utmCampaign={this.props.utmCampaign}
                    utmContent={this.props.utmContent} dealerid={this.props.dealerid} version={this.props.version}
                    AffiliateId={this.props.AffiliateId}
                    rootId={this.props.rootId}
                    deviceWidth={this.props.deviceWidth}
                    /> 
                    // :
                    // <LenderResultRowV2Mobile lender={lenderDetail}
                    // loanAmount={loanAmount}                    
                    // loanPurpose={this.GetLoanPurposeIndex(this.props.loanPurpose,3)}
                    // key={lenderDetail.lenderId}
                    // applyLink={lenderDetail.apply.link}
                    // ctaBtnLink={this.GenerateApplyLink()}
                    // redirectUrl={redirectUrl} 
                    // indexCount={count}
                    // currentDevice={this.props.currentDevice}
                    // IsPRLender={false}
                    // currentBrowser={this.props.currentBrowser}
                    // showSingleLender={this.props.showSingleLender}
                    // SID7={this.props.SID7}
                    // SID8={this.props.SID8}
                    // SID9={this.props.SID9}
                    // SID10={this.props.SID10}
                    // SortVersion={this.props.SortVersion}
                    // creditScore={this.props.creditScore}
                    // readOnly={this.props.readOnly}
                    // annualIncome={this.props.annualIncome}
                    // versionLP={this.props.versionLP}
                    // trackGoalId={trackGoalId}
                    // loanAmountBC={this.props.loanAmountBC} loanPurposeBC={this.props.loanPurposeBC}
                    // partnerid={this.props.partnerid} gclid={this.props.gclid} featured={this.props.featured}
                    // programid={this.props.programid} campaignid={this.props.campaignid} utmSource={this.props.utmSource}
                    // utmMedium={this.props.utmMedium} utmTerm={this.props.utmTerm} utmCampaign={this.props.utmCampaign}
                    // utmContent={this.props.utmContent} dealerid={this.props.dealerid} version={this.props.version}
                    // AffiliateId={this.props.AffiliateId}
                    // rootId={this.props.rootId}
                    // deviceWidth={this.props.deviceWidth}
                    // /> 
                    
                
                );
             } else {
                rows.push(
                   
                    <LenderResultRowV2 
                        loanAmount={loanAmount}  lender={primeratesDetail[0]}
                        loanPurpose={this.props.loanPurpose}
                        key={lenderDetail.lenderId}
                        applyLink={primeratesDetail[0].apply.link}
                        redirectUrl={redirectUrl} 
                        indexCount={count}
                        showSingleLender={this.props.showSingleLender}
                        currentDevice={this.props.currentDevice}
                        IsPRLender={true}
                        currentBrowser={this.props.currentBrowser}
                        SID7={this.props.SID7}
                        SID8={this.props.SID8}
                        SID9={this.props.SID9}
                        SID10={this.props.SID10}
                        SortVersion={this.props.SortVersion}
                        creditScore={this.props.creditScore}
                        readOnly={this.props.readOnly}
                        annualIncome={this.props.annualIncome}
                        versionLP={this.props.versionLP}
                        trackGoalId={trackGoalId}
                        loanAmountBC={this.props.loanAmountBC} loanPurposeBC={this.props.loanPurposeBC}
                        partnerid={this.props.partnerid} gclid={this.props.gclid} featured={this.props.featured}
                        programid={this.props.programid} campaignid={this.props.campaignid} utmSource={this.props.utmSource}
                        utmMedium={this.props.utmMedium} utmTerm={this.props.utmTerm} utmCampaign={this.props.utmCampaign}
                        utmContent={this.props.utmContent} dealerid={this.props.dealerid} version={this.props.version}
                        AffiliateId={this.props.AffiliateId}
                        rootId={this.props.rootId}
                        deviceWidth={this.props.deviceWidth}
                        />
                    
                    // <LenderResultRowV2Mobile 
                    //     loanAmount={loanAmount}  lender={primeratesDetail[0]}
                    //     loanPurpose={this.props.loanPurpose}
                    //     key={lenderDetail.lenderId}
                    //     applyLink={primeratesDetail[0].apply.link}
                    //     redirectUrl={redirectUrl} 
                    //     indexCount={count}
                    //     currentDevice={this.props.currentDevice}
                    //     IsPRLender={true}
                    //     currentBrowser={this.props.currentBrowser}
                    //     SID7={this.props.SID7}
                    //     SID8={this.props.SID8}
                    //     showSingleLender={this.props.showSingleLender}
                    //     SID9={this.props.SID9}
                    //     SID10={this.props.SID10}
                    //     SortVersion={this.props.SortVersion}
                    //     creditScore={this.props.creditScore}
                    //     readOnly={this.props.readOnly}
                    //     annualIncome={this.props.annualIncome}
                    //     versionLP={this.props.versionLP}
                    //     trackGoalId={trackGoalId}
                    //     loanAmountBC={this.props.loanAmountBC} loanPurposeBC={this.props.loanPurposeBC}
                    //     partnerid={this.props.partnerid} gclid={this.props.gclid} featured={this.props.featured}
                    //     programid={this.props.programid} campaignid={this.props.campaignid} utmSource={this.props.utmSource}
                    //     utmMedium={this.props.utmMedium} utmTerm={this.props.utmTerm} utmCampaign={this.props.utmCampaign}
                    //     utmContent={this.props.utmContent} dealerid={this.props.dealerid} version={this.props.version}
                    //     AffiliateId={this.props.AffiliateId}
                    //     rootId={this.props.rootId}   
                    //     deviceWidth={this.props.deviceWidth}
                    //     />
                );
             }
        });
    } 
        return rows;
    }

    getCreditScoreLabel() {
        const selectedCreditScore = creditScoreList.filter(creditScore => {
            return creditScore.key === this.props.creditScore;
        });
        return selectedCreditScore[0].text;
    }

    getLoanPurposeLabel() {
        const selectedLoanPurpose = loanPurposeList.filter(loanPurpose => {
            return loanPurpose.key === this.props.loanPurpose;
        });
        return selectedLoanPurpose[0].text;
    }
    GenerateApplyLink() {
        let lenderApplyLink = `${this.props.applyLink}`;        
        if(this.props.dealerid || window[this.props.rootId].dealerId) {
            // Unset the previous link //
            lenderApplyLink="";
            let delearID=this.props.dealerid?this.props.dealerid:( window[this.props.rootId].dealerId?window[this.props.rootId].dealerId:'');
            lenderApplyLink = window.applicationURL+`${lenderApplyLink}?d=${delearID}`;
            lenderApplyLink+=`&cta=lenderList`;
        }else{
            lenderApplyLink="";
            lenderApplyLink = window.applicationURL;
            lenderApplyLink+='?cta=lenderList';  
        }
        // lenderApplyLink = lenderApplyLink.replace('[clickid]', this.state.mpUniqueClickID).replace('[affiliateid]',this.props.AffiliateId);
        return  lenderApplyLink;
    }
    // showFilters() {
    //     if(this.props.iframeVersion) {
    //         try {
    //             window.parent.postMessage('ScrollToTop', `${window.iframeHost}`);
    //         } catch (error) {
    //             console.log(error);
    //         }
    //     } else {
    //         window.scroll(0, 0);
    //     }

    //     this.setState({displayFiler: true});
       
        
    //     // this.props.handleshowFilters();
    // }
    // closeFilters(){
    //     this.setState({displayFiler: false});
    // }

    render() {
        let rows = this.filterRecords();
        const applyLink = this.GenerateApplyLink();
        const ctaText = 'GET STARTED';
        const toggleImage = `https://${window.cdn  !== undefined ? window.cdn : window.location.hostname}${this.props.toggleImage}`;
        return (
          <div className="">
                <div className="">
                      {/* <HeaderIntroduction />       */}
                
                 { this.props.deviceWidth >= 768 && rows.length > 0  && ( !this.props.readOnly || this.props.readOnly !== true) && this.props.getStartedLink !== applyLink && this.props.updateGetStartedLink(applyLink)}               
                
                {/* Mobile  */}
               { this.props.deviceWidth <= 767 ?
                 rows.length > 0  && <div className={` lenderinfoV2 col-xs-7 lender-listing cta-btn`}>
                  { ( !this.props.readOnly || this.props.readOnly !== true) && <div className="contentBackground">
                  <div className={` col-lg-12 col-xs-12 `}>
                <h3 className="HeaderText">Check your personal loan rates</h3>
                <p className="subHeader">See which loans you pre-qualify for without impacting your credit score. Simply answer a few
                  questions to get estimates from top national lenders.</p>
              </div>
                    <a href={applyLink}><b className={`cta-button`}>{ctaText}</b></a> 
                </div>}
                { this.props.showSingleLender !== true &&
                  <div className=" col-xs-3 filterButton ">
                  <button onClick={this.props.showFilters} id={`update-result`} name={`update-result`}  className={` float-right filter-action`} ><img src={toggleImage} className="toggleImage"></img>Filter</button>
                  </div>} </div>
                : ''
                } 
                </div>
                <div> 
                <div className={`${this.props.showSingleLender === true ? 'col-lg-12 col-md-12' : 'col-lg-12 col-md-12'}  col-sm-12 col-xs-12 loans-offers`}>
                    {/* Desktop  */}      
                    {/* { this.state.deviceWidth > 1024 && rows.length > 0 && ( !this.props.readOnly || this.props.readOnly !== true) && this.props.showSingleLender !== true && 
                
                    } */}
                    
                    
                    <div className=" clearfix"> 
                        { rows.length > 0 ? 
                            <LoanGroupContainerV2
                                rootId={this.props.rootId}
                                isLoading={this.props.isLoading}
                                loanPurpose={this.props.loanPurpose}
                                lenders={rows}
                                showSingleLender={this.props.showSingleLender}
                                sortBy={this.state.sortBy}
                                deviceWidth={this.props.deviceWidth}
                                onSortByChange={this.handleSortByChange}/>
                        : (this.state.AcornExcludestateListArray.includes(this.props.lenderState))?
                                <div className="box-panelV2 clearfix"><div>
                                <p className="no-result"><span>{window.scrollTo(0,0)}Sorry, but Acorn Finance does not currently operate in this state.</span></p></div>
                            </div>
                            :
                            <div className="box-panelV2 clearfix"><div>
                                <p className="no-result"><span>{window.scrollTo(0,0)}Sorry, but we do not currently have any lenders with offers that meet the specified criteria.</span><br /><br /><span>If you think we have the incorrect information for you, revise your Loan Amount and other criteria in the left menu.</span></p></div>
                            </div>
                        }
                    </div> 
                    
                    {/* <HeaderIntroduction 
                    ctaBtnLink={this.GenerateApplyLink()} /> */}

                    {/* Desktop 
                    { this.state.deviceWidth > 1024 && rows.length > 0  && ( !this.props.readOnly || this.props.readOnly !== true) && this.props.showSingleLender !== true && <div className={` lenderinfoV2 lender-listing cta-btn desktop-down`}>
                        <a href={applyLink}><b className={` cta-button desktop`}>{ctaText}</b></a> 
                    </div>
                    }               */}
                </div>
                {/* Mobile  */}
                {/* { this.state.deviceWidth < 1024 && rows.length > 0  && ( !this.props.readOnly || this.props.readOnly !== true) && this.props.showSingleLender !== true && <div className={` lenderinfoV2 col-xs-7 lender-listing cta-btn`}>
                    <a href={applyLink}><b className={`cta-button`}>{ctaText}</b></a> 
                </div>
                } */}
               
            </div>
            </div>
        );
    }
}

export default MainPanelContainerV2;


// WEBPACK FOOTER //
// ./src/MainPanelContainerV2.js